import React from 'react';
import { COLORS } from '../config/theme';

// ============================================================
// ICON COMPONENT (inline SVG)
// ============================================================
export const Icon = ({ name, size = 20, color = COLORS.green, style: s, ...props }) => {
  const icons = {
    home: <><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    briefcase: <><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    receipt: <><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M8 7h8"/><path d="M8 11h8"/><path d="M8 15h4"/></>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    fileText: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
    calculator: <><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="8" y2="10.01"/><line x1="12" y1="10" x2="12" y2="10.01"/><line x1="16" y1="10" x2="16" y2="10.01"/><line x1="8" y1="14" x2="8" y2="14.01"/><line x1="12" y1="14" x2="12" y2="14.01"/><line x1="16" y1="14" x2="16" y2="14.01"/><line x1="8" y1="18" x2="8" y2="18.01"/><line x1="12" y1="18" x2="12" y2="18.01"/><line x1="16" y1="18" x2="16" y2="18.01"/></>,
    plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    search: <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    chevronRight: <><polyline points="9 18 15 12 9 6"/></>,
    chevronLeft: <><polyline points="15 18 9 12 15 6"/></>,
    x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    check: <><polyline points="20 6 9 17 4 12"/></>,
    upload: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></>,
    camera: <><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></>,
    dollarSign: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></>,
    trendingUp: <><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></>,
    users: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
    menu: <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>,
    eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    edit: <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    trash: <><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    send: <><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>,
    satellite: <><circle cx="12" cy="12" r="2"/><path d="M7.05 7.05A7 7 0 0 0 5 12c0 1.93.78 3.68 2.05 4.95"/><path d="M16.95 16.95A7 7 0 0 0 19 12a7 7 0 0 0-2.05-4.95"/><path d="M3.34 3.34A12 12 0 0 0 1 12c0 3.31 1.34 6.31 3.51 8.49"/><path d="M20.66 20.66A12 12 0 0 0 23 12c0-3.31-1.34-6.31-3.51-8.49"/></>,
    logOut: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    alertCircle: <><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></>,
    checkCircle: <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>,
    truck: <><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></>,
    rocket: <><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></>,
    leaf: <><path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 20 2 20 2s-1.1 4.7-3.2 8.1"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 12 13"/><path d="M5.08 15C2.85 15.36 2 18 2 21"/><path d="M20 2s.3 4.4-4.2 9c-1.7 1.7-3.5 2.7-5 3.2"/></>,
    sprout: <><path d="M7 20h10"/><path d="M10 20c5.5-2.5.8-6.4 3-10"/><path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"/><path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={s} {...props}>
      {icons[name] || icons.alertCircle}
    </svg>
  );
};

// ============================================================
// CARD
// ============================================================
export const GlowCard = ({ children, onClick, style: s, glow, ...props }) => (
  <div onClick={onClick} {...props}
    style={{
      background: COLORS.bgCard, border: `1px solid ${glow ? COLORS.greenDim : COLORS.border}`,
      borderRadius: 12, padding: '16px 20px', cursor: onClick ? 'pointer' : 'default',
      transition: 'all 0.2s ease', boxShadow: glow ? `0 0 20px ${COLORS.greenGlow}` : 'none',
      ...s,
    }}
    onMouseEnter={e => { if (onClick) { e.currentTarget.style.background = COLORS.bgCardHover; e.currentTarget.style.borderColor = COLORS.greenDim; }}}
    onMouseLeave={e => { if (onClick) { e.currentTarget.style.background = COLORS.bgCard; e.currentTarget.style.borderColor = glow ? COLORS.greenDim : COLORS.border; }}}
  >{children}</div>
);

// ============================================================
// BUTTON
// ============================================================
export const Button = ({ children, variant = 'primary', size = 'md', icon, onClick, disabled, style: s, ...props }) => {
  const variants = {
    primary: { bg: COLORS.green, color: '#0a0f0a', hoverBg: COLORS.greenDim },
    secondary: { bg: 'transparent', color: COLORS.green, hoverBg: COLORS.greenGlow, border: `1px solid ${COLORS.border}` },
    danger: { bg: COLORS.dangerDim, color: '#fff', hoverBg: COLORS.danger },
    ghost: { bg: 'transparent', color: COLORS.textDim, hoverBg: COLORS.greenGlow },
    gold: { bg: COLORS.gold, color: '#0a0f0a', hoverBg: COLORS.goldDim },
  };
  const sizes = { sm: { padding: '6px 12px', fontSize: 13 }, md: { padding: '10px 18px', fontSize: 14 }, lg: { padding: '14px 24px', fontSize: 16 } };
  const v = variants[variant] || variants.primary;
  const sz = sizes[size] || sizes.md;
  return (
    <button onClick={onClick} disabled={disabled} {...props}
      style={{
        background: v.bg, color: v.color, border: v.border || 'none', borderRadius: 8,
        ...sz, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex', alignItems: 'center', gap: 8, opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s ease', fontFamily: 'inherit', ...s,
      }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = v.hoverBg; }}
      onMouseLeave={e => { if (!disabled) e.currentTarget.style.background = v.bg; }}
    >
      {icon && <Icon name={icon} size={size === 'sm' ? 14 : 16} color={v.color} />}
      {children}
    </button>
  );
};

// ============================================================
// INPUT
// ============================================================
export const Input = ({ label, value, onChange, type = 'text', placeholder, prefix, textarea, ...props }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    {label && <label style={{ fontSize: 13, color: COLORS.textDim, fontWeight: 500 }}>{label}</label>}
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      {prefix && <span style={{ position: 'absolute', left: 12, color: COLORS.textMuted, fontSize: 14 }}>{prefix}</span>}
      {textarea ? (
        <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
          style={{
            background: COLORS.bgInput, border: `1px solid ${COLORS.border}`, borderRadius: 8,
            padding: '10px 14px', color: COLORS.text, fontSize: 14, width: '100%', minHeight: 80,
            fontFamily: 'inherit', outline: 'none', resize: 'vertical',
          }}
          onFocus={e => e.target.style.borderColor = COLORS.greenDim}
          onBlur={e => e.target.style.borderColor = COLORS.border}
          {...props} />
      ) : (
        <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
          style={{
            background: COLORS.bgInput, border: `1px solid ${COLORS.border}`, borderRadius: 8,
            padding: '10px 14px', paddingLeft: prefix ? 30 : 14, color: COLORS.text, fontSize: 14,
            width: '100%', fontFamily: 'inherit', outline: 'none',
          }}
          onFocus={e => e.target.style.borderColor = COLORS.greenDim}
          onBlur={e => e.target.style.borderColor = COLORS.border}
          {...props} />
      )}
    </div>
  </div>
);

// ============================================================
// SELECT
// ============================================================
export const Select = ({ label, value, onChange, options, placeholder }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    {label && <label style={{ fontSize: 13, color: COLORS.textDim, fontWeight: 500 }}>{label}</label>}
    <select value={value} onChange={e => onChange(e.target.value)}
      style={{
        background: COLORS.bgInput, border: `1px solid ${COLORS.border}`, borderRadius: 8,
        padding: '10px 14px', color: COLORS.text, fontSize: 14, fontFamily: 'inherit',
        outline: 'none', cursor: 'pointer', appearance: 'none',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%234ade80' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center',
      }}>
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(o => <option key={typeof o === 'string' ? o : o.value} value={typeof o === 'string' ? o : o.value}>
        {typeof o === 'string' ? o : o.label}
      </option>)}
    </select>
  </div>
);

// ============================================================
// BADGE
// ============================================================
export const Badge = ({ children, color = COLORS.green }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', padding: '3px 10px', borderRadius: 20,
    fontSize: 12, fontWeight: 600, color, background: `${color}18`, border: `1px solid ${color}30`,
  }}>{children}</span>
);

export const StatusBadge = ({ status }) => {
  const map = {
    active: { color: COLORS.green, label: 'Active' },
    completed: { color: COLORS.gold, label: 'Completed' },
    archived: { color: COLORS.textMuted, label: 'Archived' },
    draft: { color: COLORS.textDim, label: 'Draft' },
    sent: { color: COLORS.warning, label: 'Sent' },
    paid: { color: COLORS.green, label: 'Paid' },
    overdue: { color: COLORS.danger, label: 'Overdue' },
  };
  const s = map[status] || map.active;
  return <Badge color={s.color}>{s.label}</Badge>;
};

// ============================================================
// STAT
// ============================================================
export const Stat = ({ label, value, sub, icon }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
    {icon && (
      <div style={{
        width: 42, height: 42, borderRadius: 10, background: COLORS.greenGlow,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: `1px solid ${COLORS.border}`,
      }}>
        <Icon name={icon} size={20} color={COLORS.green} />
      </div>
    )}
    <div>
      <div style={{ fontSize: 13, color: COLORS.textDim, marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: COLORS.text, letterSpacing: '-0.02em' }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: COLORS.textMuted, marginTop: 1 }}>{sub}</div>}
    </div>
  </div>
);

// ============================================================
// MODAL
// ============================================================
export const Modal = ({ title, onClose, children, wide }) => (
  <div style={{
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20,
    backdropFilter: 'blur(4px)',
  }} onClick={onClose}>
    <div onClick={e => e.stopPropagation()} style={{
      background: COLORS.bg, border: `1px solid ${COLORS.border}`, borderRadius: 16,
      width: '100%', maxWidth: wide ? 700 : 500, maxHeight: '90vh', overflow: 'auto',
      boxShadow: `0 0 40px ${COLORS.greenGlow}`,
    }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '18px 24px', borderBottom: `1px solid ${COLORS.border}`,
      }}>
        <h3 style={{ margin: 0, color: COLORS.text, fontSize: 18, fontWeight: 600 }}>{title}</h3>
        <button onClick={onClose} style={{
          background: 'none', border: 'none', cursor: 'pointer', padding: 4,
          display: 'flex', alignItems: 'center',
        }}>
          <Icon name="x" size={20} color={COLORS.textDim} />
        </button>
      </div>
      <div style={{ padding: 24 }}>{children}</div>
    </div>
  </div>
);

// ============================================================
// TOAST NOTIFICATION
// ============================================================
export const Toast = ({ message, type = 'success', onClose }) => {
  const colors = {
    success: COLORS.green,
    error: COLORS.danger,
    warning: COLORS.warning,
    info: COLORS.textDim,
  };
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 2000,
      background: COLORS.bgCard, border: `1px solid ${colors[type]}`,
      borderRadius: 10, padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 10,
      boxShadow: `0 4px 20px rgba(0,0,0,0.4)`, maxWidth: 400,
      animation: 'slideUp 0.3s ease',
    }}>
      <style>{`@keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
      <Icon name={type === 'success' ? 'checkCircle' : type === 'error' ? 'alertCircle' : 'alertCircle'} size={18} color={colors[type]} />
      <span style={{ fontSize: 14, color: COLORS.text, flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2 }}>
        <Icon name="x" size={14} color={COLORS.textMuted} />
      </button>
    </div>
  );
};

// ============================================================
// PAGE HEADER
// ============================================================
export const PageHeader = ({ title, subtitle, actions, currentUser }) => (
  <div style={{
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    marginBottom: 28, flexWrap: 'wrap', gap: 16,
  }}>
    <div>
      <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: COLORS.text, letterSpacing: '-0.02em' }}>{title}</h1>
      {subtitle && <p style={{ margin: '4px 0 0', fontSize: 14, color: COLORS.textDim }}>{subtitle}</p>}
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {actions}
      {currentUser && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8, padding: '6px 14px',
          background: COLORS.bgCard, borderRadius: 8, border: `1px solid ${COLORS.border}`,
        }}>
          <div style={{ width: 28, height: 28, borderRadius: '50%', background: COLORS.greenGlow, display: 'flex', alignItems: 'center', justifyContent: 'center', border: `1px solid ${COLORS.border}` }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: COLORS.green }}>{currentUser[0]}</span>
          </div>
          <span style={{ fontSize: 13, color: COLORS.textDim }}>{currentUser}</span>
        </div>
      )}
    </div>
  </div>
);

// ============================================================
// SIDEBAR
// ============================================================
export const Sidebar = ({ currentPage, setPage, collapsed, setCollapsed, onLogout }) => {
  const navItems = [
    { id: 'dashboard', label: 'Mission Control', icon: 'satellite' },
    { id: 'jobs', label: 'Jobs', icon: 'briefcase' },
    { id: 'receipts', label: 'Receipts', icon: 'receipt' },
    { id: 'time', label: 'Labor Journal', icon: 'clock' },
    { id: 'invoices', label: 'Invoices', icon: 'fileText' },
    { id: 'tax', label: 'Tax Prep', icon: 'calculator' },
  ];

  return (
    <div style={{
      width: collapsed ? 64 : 220, height: '100vh', background: COLORS.bg,
      borderRight: `1px solid ${COLORS.border}`, display: 'flex', flexDirection: 'column',
      transition: 'width 0.2s ease', flexShrink: 0, overflow: 'hidden',
    }}>
      <div style={{
        padding: collapsed ? '16px 8px' : '16px', borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex', alignItems: 'center', gap: 12, minHeight: 72,
      }}>
        <div style={{
          width: collapsed ? 44 : 48, height: collapsed ? 44 : 48, borderRadius: 10, background: COLORS.greenGlow,
          border: `1px solid ${COLORS.greenDim}`, display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0, boxShadow: `0 0 12px ${COLORS.greenGlow}`,
        }}>
          <svg width={collapsed ? 28 : 32} height={collapsed ? 28 : 32} viewBox="0 0 100 100" fill="none">
            <line x1="38" y1="90" x2="47" y2="50" stroke={COLORS.green} strokeWidth="3"/>
            <line x1="62" y1="90" x2="53" y2="50" stroke={COLORS.green} strokeWidth="3"/>
            <line x1="41" y1="72" x2="59" y2="72" stroke={COLORS.green} strokeWidth="2"/>
            <line x1="50" y1="50" x2="50" y2="18" stroke={COLORS.green} strokeWidth="3.5"/>
            <circle cx="50" cy="18" r="6" fill={COLORS.green} opacity="0.8"/>
            <circle cx="50" cy="18" r="3" fill={COLORS.green}/>
            <circle cx="50" cy="18" r="14" stroke={COLORS.green} strokeWidth="2" fill="none" opacity="0.5"/>
            <circle cx="50" cy="18" r="24" stroke={COLORS.green} strokeWidth="1.5" fill="none" opacity="0.25"/>
            <circle cx="50" cy="18" r="34" stroke={COLORS.green} strokeWidth="1" fill="none" opacity="0.12"/>
            <rect x="32" y="88" width="36" height="5" rx="2.5" fill={COLORS.green}/>
          </svg>
        </div>
        {!collapsed && (
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: COLORS.green, letterSpacing: '0.05em', lineHeight: 1.1 }}>GROUND</div>
            <div style={{ fontSize: 12, fontWeight: 500, color: COLORS.textMuted, letterSpacing: '0.1em' }}>CONTROL</div>
          </div>
        )}
      </div>

      <div style={{ flex: 1, padding: '12px 8px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {navItems.map(item => {
          const active = currentPage === item.id;
          return (
            <button key={item.id} onClick={() => setPage(item.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: collapsed ? '10px 12px' : '10px 14px',
                background: active ? COLORS.greenGlow : 'transparent',
                border: active ? `1px solid ${COLORS.border}` : '1px solid transparent',
                borderRadius: 8, cursor: 'pointer', color: active ? COLORS.green : COLORS.textDim,
                fontSize: 14, fontWeight: active ? 600 : 400, fontFamily: 'inherit',
                transition: 'all 0.15s ease', textAlign: 'left', width: '100%',
                justifyContent: collapsed ? 'center' : 'flex-start',
              }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.background = COLORS.greenGlow; e.currentTarget.style.color = COLORS.green; }}}
              onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = COLORS.textDim; }}}
            >
              <Icon name={item.icon} size={18} color={active ? COLORS.green : COLORS.textMuted} />
              {!collapsed && item.label}
            </button>
          );
        })}
      </div>

      <div style={{ padding: '12px 8px', borderTop: `1px solid ${COLORS.border}`, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {onLogout && (
          <button onClick={onLogout}
            style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: collapsed ? '10px 12px' : '10px 14px',
              background: 'transparent', border: '1px solid transparent', borderRadius: 8,
              cursor: 'pointer', color: COLORS.textMuted, fontSize: 13, fontFamily: 'inherit',
              width: '100%', justifyContent: collapsed ? 'center' : 'flex-start',
            }}>
            <Icon name="logOut" size={16} color={COLORS.textMuted} />
            {!collapsed && 'Log Out'}
          </button>
        )}
        <button onClick={() => setCollapsed(!collapsed)}
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: collapsed ? '10px 12px' : '10px 14px',
            background: 'transparent', border: '1px solid transparent', borderRadius: 8,
            cursor: 'pointer', color: COLORS.textMuted, fontSize: 13, fontFamily: 'inherit',
            width: '100%', justifyContent: collapsed ? 'center' : 'flex-start',
          }}>
          <Icon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={16} color={COLORS.textMuted} />
          {!collapsed && 'Collapse'}
        </button>
      </div>
    </div>
  );
};

// ============================================================
// LOADING SPINNER
// ============================================================
export const Spinner = ({ size = 48, label }) => (
  <div style={{ textAlign: 'center', padding: '40px 20px' }}>
    <div style={{
      width: size, height: size, borderRadius: '50%', border: `3px solid ${COLORS.border}`,
      borderTopColor: COLORS.green, margin: '0 auto', animation: 'spin 1s linear infinite',
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    {label && <div style={{ fontSize: 14, color: COLORS.textDim, marginTop: 12 }}>{label}</div>}
  </div>
);
